import { render, staticRenderFns } from "./socios.vue?vue&type=template&id=033e37df&scoped=true"
import script from "./socios.vue?vue&type=script&lang=js"
export * from "./socios.vue?vue&type=script&lang=js"
import style0 from "./socios.vue?vue&type=style&index=0&id=033e37df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e37df",
  null
  
)

export default component.exports